<template>
  <div>
    <div class="card">
      <div class="card-header">
        Team Admin
        <div v-if="loadingData" class="card-header-actions">
          <small class="text-muted">Loading...</small>
        </div>
      </div>
      <div class="card-body">
        <div id="Itemlist">
          <table class="table">
              <tr>
                  <th>Name</th>
                  <th>Value</th>
              </tr>
              <tr v-for="siteVar in siteVars">
                  <td>{{siteVar.name}}</td>
                  <td>
                    <CInput :value="siteVar.value" :id="'sitevar-' + siteVar.name" @change="changeSiteVar" />
                  </td>
              </tr>
              <tr>
                <td> </td>
                <td>
                  <CButton :color="loadingData ? 'secondary' : 'primary'" @click="saveSiteVars()">Update</CButton>
                </td>
              </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteVars',
  data() {
    return {
      changedSiteVars: {}
    }
  },
  created() {
    this.$store.dispatch("loadSiteVarsList", {clubId:1});
  },
  methods: {
    saveSiteVars: function() {
      this.$store.dispatch("saveSiteVarsList", {siteVars: this.changedSiteVars});
    },
    changeSiteVar: function(newValue, event) {
      const key = event.target.id.split("-")[1];
      this.changedSiteVars[key] = newValue;
    }
  },
  computed: {
    siteVars: function() {
      return this.$store.state.siteVarsList.list;
    },
    loadingData: function() {
      return this.$store.state.siteVarsList.loading;
    }
  }
}
</script>
